import {
    VIDFLEET_CLIP_REQUESTS_DETAILS_OPEN_MODAL,
    VIDFLEET_CLIP_REQUESTS_DETAILS_REQUEST,
    VIDFLEET_CLIP_REQUESTS_DETAILS_RESULT,
} from 'Redux/actionTypes';

export const vidfleetClipRequestDetailsOpenModal = (open, data) => ({
    type: VIDFLEET_CLIP_REQUESTS_DETAILS_OPEN_MODAL,
    payload: { open, data }
})

export const vidfleetClipRequestDetailsRequest = (data) => ({
    type: VIDFLEET_CLIP_REQUESTS_DETAILS_REQUEST,
    payload: { data }
})

export const vidfleetClipRequestDetailsResult = (data) => ({
    type: VIDFLEET_CLIP_REQUESTS_DETAILS_RESULT,
    payload: { data }
})